var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCornerGoldTl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4v12L16 0H4a4 4 0 00-4 4z",
    fill: "url(#paint2_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.5 14.8V4A3.5 3.5 0 014 .5h10.8L.5 14.8z",
    stroke: "#FFE99D",
    strokeOpacity: 0.35
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 3,
    y1: 1.5,
    x2: 11.55,
    y2: 12.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3C58A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#735F3A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerGoldTl);
export default __webpack_public_path__ + "static/media/corner-gold-tl.bcdc2354ab25c29f2f9d05c4f5c40e6b.svg";
export { ForwardRef as ReactComponent };